import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetForm, usePatchForm } from 'api/forms';
import { ConfirmationDialogModal } from 'components/shared';
import { useShowNotification } from 'hooks';
import { KeyIcon } from 'icons';

import { useFormEditContext } from '../../context';
import { SharingSettingsBox } from './SharingSettingsBox';
import { PasswordModal } from './PasswordModal';

export const SharingSettingsPassword = () => {
  const {
    form: { id, accessCode },
  } = useFormEditContext();
  const isSet = accessCode !== null;
  const [editModalOpened, setEditModalOpened] = useState(false);
  const [deleteModalOpened, setDeleteModalOpened] = useState(false);
  const { t } = useTranslation('forms');

  const { refetch: refetchForm } = useGetForm({ id });
  const { mutateAsync: patchForm } = usePatchForm({ id });

  const showNotification = useShowNotification();

  const onPasswordDelete = async () => {
    try {
      await patchForm({ accessCode: null });
      showNotification({
        message: t(
          'editView.sidebar.sharing.settings.password.deletionSuccessToast',
        ),
        color: 'green',
      });
      setDeleteModalOpened(false);
      refetchForm();
    } catch (error) {
      showNotification({
        message: t(
          'editView.sidebar.sharing.settings.password.deletionErrorToast',
        ),
        color: 'red',
      });
    }
  };

  const stateDescription = isSet
    ? t('editView.sidebar.sharing.settings.password.state.set')
    : t('editView.sidebar.sharing.settings.password.state.notSet');

  return (
    <>
      <SharingSettingsBox
        title={t('editView.sidebar.sharing.settings.password.title')}
        description={stateDescription}
        icon={<KeyIcon />}
        onSetButtonClick={() => setEditModalOpened(true)}
        onEditButtonClick={() => setEditModalOpened(true)}
        onDeleteButtonClick={() => setDeleteModalOpened(true)}
        isSet={isSet}
      />
      <PasswordModal
        opened={editModalOpened}
        onClose={() => setEditModalOpened(false)}
      />
      <ConfirmationDialogModal
        title={t(
          'editView.sidebar.sharing.settings.password.confirmationDialog.title',
        )}
        message={t(
          'editView.sidebar.sharing.settings.password.confirmationDialog.message',
        )}
        opened={deleteModalOpened}
        onClose={() => setDeleteModalOpened(false)}
        onConfirm={onPasswordDelete}
        confirmButtonText={t(
          'editView.sidebar.sharing.settings.password.confirmationDialog.confirmButton',
        )}
        variant="danger"
      />
    </>
  );
};
